import { render, staticRenderFns } from "./UserCenterinfoNot.vue?vue&type=template&id=2861cec0&scoped=true"
import script from "./UserCenterinfoNot.vue?vue&type=script&lang=js"
export * from "./UserCenterinfoNot.vue?vue&type=script&lang=js"
import style0 from "./UserCenterinfoNot.vue?vue&type=style&index=0&id=2861cec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2861cec0",
  null
  
)

export default component.exports